export default __webpack_public_path__ + "help_every_step.3ba1d145.png";